export const services = [
  {
    id: 1,
    title: 'Demolition Services',
    description: 'Safe and efficient demolition for residential and commercial properties. We handle interior gut-outs, full structure removal, and selective demolition with precision.',
    icon: 'ri-building-2-line',
    items: ['Interior Demolition', 'Structural Removal', 'Selective Demolition', 'Debris Cleanup'],
  },
  {
    id: 2,
    title: 'Full Reconstruction',
    description: 'Complete rebuilding services from foundation to finish. We reconstruct homes and commercial spaces with quality materials and expert craftsmanship.',
    icon: 'ri-home-gear-line',
    items: ['Structural Rebuilding', 'Framing & Drywall', 'Roofing & Siding', 'Exterior Finishing'],
  },
  {
    id: 3,
    title: 'Kitchen Remodeling',
    description: 'Transform your kitchen into a modern, functional space. From cabinets to countertops, we handle every detail of your kitchen renovation.',
    icon: 'ri-restaurant-line',
    items: ['Cabinet Installation', 'Countertop Replacement', 'Appliance Upgrades', 'Plumbing & Electrical'],
  },
  {
    id: 4,
    title: 'Bathroom Renovations',
    description: 'Upgrade your bathrooms with new fixtures, tile work, and modern designs. We create beautiful and functional bathroom spaces.',
    icon: 'ri-showers-line',
    items: ['Tile Installation', 'Fixture Replacement', 'Shower & Tub Upgrades', 'Vanity Installation'],
  },
  {
    id: 5,
    title: 'General Handyman',
    description: 'From minor repairs to major improvements, our skilled handyman team handles all your home maintenance and repair needs quickly and professionally.',
    icon: 'ri-tools-line',
    items: ['Drywall Repair', 'Door & Window Repair', 'Painting & Staining', 'Flooring Repair'],
  },
  {
    id: 6,
    title: 'Emergency Repairs',
    description: 'When disaster strikes, we are here to help. Our emergency response team handles storm damage, water damage, and urgent structural repairs.',
    icon: 'ri-first-aid-kit-line',
    items: ['Storm Damage Repair', 'Water Damage Restoration', 'Emergency Board-Up', '24/7 Response'],
  },
];

export const galleryProjects = [
  {
    id: 1,
    title: 'Bathroom Renovation',
    location: 'South Florida',
    type: 'Bathroom Remodel',
    duration: '1 Week',
    beforeImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/399b25da-851c-4a83-b974-8a38e16e7ea3_IMG_8627.jpeg',
    afterImage: 'https://storage.readdy-site.link/project_files/cbe9c8f1-30fe-4956-b820-91a56929acf4/36094d3a-1626-49ba-9c5e-4a702dde65dc_IMG_8738.jpeg',
  },
];

export const stats = [
  { number: '500+', label: 'Completed Projects' },
  { number: '15+', label: 'Years Experience' },
  { number: '98%', label: 'Client Satisfaction' },
  { number: '24/7', label: 'Emergency Response' },
];

export const values = [
  {
    id: 1,
    title: 'Licensed & Insured',
    description: 'Fully licensed, bonded, and insured for your protection. We carry comprehensive liability and workers compensation insurance on every project.',
    icon: 'ri-shield-check-line',
  },
  {
    id: 2,
    title: 'Quality Craftsmanship',
    description: 'Every project is completed to the highest standards. Our experienced team uses premium materials and proven techniques for lasting results.',
    icon: 'ri-medal-line',
  },
  {
    id: 3,
    title: 'Transparent Pricing',
    description: 'No hidden fees, no surprises. We provide detailed written estimates upfront so you know exactly what to expect from start to finish.',
    icon: 'ri-file-list-3-line',
  },
];

export const serviceAreas = [
  'Miami',
  'Fort Lauderdale',
  'West Palm Beach',
  'Boca Raton',
  'Hollywood',
  'Pompano Beach',
  'Coral Springs',
];